import {
  FeatureFlagDashboard_properties as propertiesType,
  FeatureFlagDashboard_featureFlags as featureFlagType,
  Feature,
} from "types/gql-types";

type PropertyMap = {
  [name: string]: string;
}

type FeatureFlagMap = {
  [name: string]: Feature;
}

export const propertyLookup = (properties: propertiesType[]): PropertyMap =>
  properties.reduce((acc, property) => {
    acc[property.id] = property.name;
    return acc;
  }, {} as PropertyMap);

export const featureFlagLookup = (features: featureFlagType[]): FeatureFlagMap =>
  features.reduce((acc, feature) => {
    acc[feature.id] = feature.name;
    return acc;
  }, {} as FeatureFlagMap);
